import { render, staticRenderFns } from "./empty-en.vue?vue&type=template&id=6cf8adb0&scoped=true&"
import script from "./empty-en.vue?vue&type=script&lang=js&"
export * from "./empty-en.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cf8adb0",
  null
  
)

export default component.exports